"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMetricsActionPublisherAsync = exports.initAndResolveMetricsPublisher = void 0;
const katal_metrics_driver_sushi_1 = __importDefault(require("@amzn/katal-metrics-driver-sushi"));
const katal_metrics_1 = require("@amzn/katal-metrics");
const session_1 = require("./session");
const metrics_config_1 = require("./metrics_config");
const PROD = 'prod';
const PRE_PROD = 'test';
const US_AMAZON = 'USAmazon';
/*
  Immediately create and return an async handle on the Katal publisher instance.

  The resulting async handler can be resolved with a Publisher instance by calling
  the `handle.resolvePublisher` function.

  We've re-purposed a Promise to expose the internal resolve externally within this module.
*/
const createPublisherHandle = () => {
    let resolvePublisher = null;
    let initialized = false;
    const publisher = new Promise((resolve) => {
        // promise executor is called immediately allowing us to expose resolve and assign resolvePublisher
        // https://stackoverflow.com/questions/42118900/when-is-the-body-of-a-promise-executed
        resolvePublisher = resolve;
    });
    publisher.then(() => {
        initialized = true;
    });
    if (!resolvePublisher) {
        throw 'Failed to initialize async Katal handle';
    }
    return {
        publisher,
        resolvePublisher,
        initialized,
    };
};
let publisherHandle = createPublisherHandle();
const initPublisher = (config) => {
    var _a;
    return new katal_metrics_1.Publisher(new katal_metrics_driver_sushi_1.default.Builder().withDomainRealm(metrics_config_1.isProd(config) ? PROD : PRE_PROD, (_a = config.realm) !== null && _a !== void 0 ? _a : US_AMAZON).build(), undefined, new katal_metrics_1.Context.Builder()
        .withSite(config.site)
        .withServiceName(metrics_config_1.getAppStageName(config))
        .withRelatedMetrics(new katal_metrics_1.Metric.String('http_request_id', session_1.getHttpRequestId()), new katal_metrics_1.Metric.String('session_id', session_1.getSessionId()), ...(config.relatedMetrics ? config.relatedMetrics() : []))
        .build());
};
exports.initAndResolveMetricsPublisher = (config) => {
    if (publisherHandle.initialized) {
        publisherHandle = createPublisherHandle();
    }
    // Initialize a publisher with the given config
    // and resolve the async publisherHandle
    publisherHandle.resolvePublisher(initPublisher(config));
};
exports.getMetricsActionPublisherAsync = (method) => publisherHandle.publisher.then((p) => p.newChildActionPublisherForMethod(method));
